import React from "react";
import PropTypes from 'prop-types';
import MembersApi from "../../../services/portal-api/MembersApi";
import { Link, Redirect } from 'react-router-dom';
import AuthService from "../../../services/AuthService";
import TextInput from "../../../components/Form/components/TextInput";
import SelectInput from "../../../components/Form/components/SelectInput";
import Pagination from "react-js-pagination";
import swal from 'sweetalert';
import { FcDataConfiguration, FcServices, FcManager, FcGlobe, FcSynchronize } from "react-icons/fc";
import moment from "moment/moment";
import NotFound from "../../NotFound";

class UserTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setting: {
                STORE_ADMIN_TIMEOUT: 0,
                SUPER_ADMIN_TIMEOUT: 0,
                STORE_USER_TIMEOUT: 0,
                CUST_ADMIN_TIMEOUT: 0,
                AREA_MANAGER_TIMEOUT: 0
            },
            errors: {},
            search: '',
            selectedStore: '',
            selectedRole: '',
            usernameSort: 'ASC',
            lastLoggedInSort: 'ASC',
            // currentPage: 1,
            // itemsPerPage: 50
        };
    }

    componentDidMount() {
        this._loadSettings();
    }

    _loadSettings = () => {
        MembersApi.getSettingsAll((response) => {
            if (response.success) {
                const { setting } = this.state;
                response.json.settings.forEach((v, k) => {
                    setting[v.setting_keys] = (v.setting_keys != undefined || v.setting_keys != '') ? v.setting_values : 0;
                }); "moment"
                this.setState({
                    setting: setting
                });
            }
        });
    }

    handleInputs = (id, type, amId = null) => {
        swal({
            title: "Are you sure?",
            text: "you really want to " + type + " this user account?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                const handleButtonClick = (response) => {
                    if (response.success) {
                        if (type == 'Delete' || type == 'delete') {
                            this.props.removeUser(id);
                        } else {
                            this.props.updateIsActive();
                        }

                        swal(response.json.message, {
                            icon: "success",
                            buttons: false,
                            timer: 3000
                        });
                    }
                }

                if (amId == null) {
                    MembersApi.delUser(handleButtonClick, id, type);
                } else {
                    MembersApi.delUserByAM(handleButtonClick, id, type, amId);
                }

            } else {
                swal(`You have cancelled the ${type} action`, {
                    buttons: false,
                    timer: 2000
                });
            }
        });
    }

    handleSearch = (event) => {
        const value = event.target.value;
        this.setState({
            search: value,
            selectedStore: '',
            selectedRole: ''
        });
        this.props.searchUsers(value);
    }

    handleStoreChange = (event) => {
        const value = event.target.value;
        this.setState({
            selectedStore: value,
            selectedRole: '',
            search: ''
        });
        this.props.searchStore(value);
    }

    handleRoleChange = (event) => {
        const value = event.target.value;
        this.setState({
            selectedRole: value,
            selectedStore: '',
            search: ''
        });
        this.props.searchRole(value == 100 ? 0 : value);
    }

    handleUsernameSort = (column) => {  
        if(column == 'last_logged_in_time') {
            this.setState(prevState => ({
                lastLoggedInSort: prevState.lastLoggedInSort == 'ASC' ? 'DESC' : 'ASC'
                
            }), () => {
                console.log('lastLoggedInSort selected');
            })
        } 

        if(column == 'username') {
            this.setState(prevState => ({
                usernameSort: prevState.usernameSort == 'ASC' ? 'DESC' : 'ASC'
                
            }), () => {
                console.log('usernameSort selected');
            })
        }

        this.props.sort(column, this.state.search, this.state.selectedStore, this.state.selectedRole == 100 ? 0 : this.state.selectedRole);
    }

    roles = () => {
        return [
            { key: 100, value: 'Store User' },
            { key: 2, value: 'Store Admin' },
            { key: 3, value: 'Customer Support Admin' },
            { key: 1, value: 'Super Admin' },
        ];
    }

    handlePageRefresh = () => {
        this.setState({
            search: '',
            selectedStore: '',
            selectedRole: '',
        });
        this.props.searchUsers('');
    }

    _defaultSettings = (admin, setting) => {
        switch (admin) {
            case 0:
                return setting.STORE_USER_TIMEOUT;
            case 1:
                return setting.SUPER_ADMIN_TIMEOUT;
            case 2:
                return setting.STORE_ADMIN_TIMEOUT;
            case 3:
                return setting.CUST_ADMIN_TIMEOUT;
            case 4:
                return setting.AREA_MANAGER_TIMEOUT;
            default:
                return 0;
        };
    }

    handlePageChange = (pageNumber) => {
        this.props.handlePageChange(pageNumber, this.state.selectedStore, this.state.selectedRole == 100 ? 0 : this.state.selectedRole);
    };

    convertUTCToLocalTime = (dateSritng) => {
        if (dateSritng == null || dateSritng == '') {
            return '';
        } else {
            let date = new Date(dateSritng);
            const milliseconds = Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds(),
            );
            const localTime = new Date(milliseconds);

            let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
            return moment(cd).format('DD/MM/YYYY h:mm A');
        }

    };

    render() {
        const { setting } = this.state;
        const paginationStyles = {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            marginTop: '10px',
        };

        const rows = [];
        let propUsers = [];
        let filteredLength = 1;

        if (this.props.isFiltering) {
            propUsers = this.props.filteredUsers;
            filteredLength = propUsers.length == 0 ? filteredLength : this.props.totalUsers;
        } else {
            propUsers = this.props.paginatedUsers;
        }
        console.log("🚀 ~ file: UserTable.js:137 ~ UserTable ~ render ~ propUsers:", propUsers.length);

        propUsers.forEach((user, index) => {
            let setto = 0;
            setto = this._defaultSettings(user.isAdmin, setting);

            rows.push(
                <tr key={index}>
                    <td style={{ overflowWrap: 'anywhere' }}><strong>{user.username}</strong></td>
                    {window.location.pathname == '/new-users' &&
                        <td>
                            {user.associatedStores.map((store, index) => (

                                    <div key={store.storeId}>
                                        <strong>
                                            {store.role === 'Area Manager' ? store.store : (
                                                <React.Fragment>
                                                    {store.store} {getIconForRole(store.role)}
                                                </React.Fragment>
                                            )}
                                        </strong>
                                        {index !== user.associatedStores.length - 1 && <strong>, </strong>}
                                    </div>
                                ))}
                            </td>
                    }

                
                    <td><strong>{user.timeout == 0 ? (user.isGlobal == 0 ? "Unlimited" : (setto == 0 ? "Global (Unlimited)" : `Global (${setto} Mins)`)) : user.timeout + " min"}</strong></td>

                    <td><strong>{user.currentStore}</strong></td>
                    <td>
                        {/* <strong>{(user.createdOn != null && user.createdOn != '') && this.convertUTCToLocalTime(user.createdOn)}</strong> */}
                        <strong>{user.createdOn}</strong>
                    </td>
                    <td>
                        <table style={{ marginTop: 0 }}>
                            <tbody>
                                <tr>
                                    {(AuthService.can('Edit users') || AuthService.can('Edit area managers') || (AuthService.can('edit store users') && AuthService.getAdminType() == 4)) &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <Link to={{ 'pathname': '/multiUser/' + user.id, 'state': { 'prevPath': location.pathname } }} className="btn btn--xsmall btn--color btn--open">Edit <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" /></Link>
                                        </td>
                                    }
                                    {(AuthService.getAdminType() == 1 && (AuthService.can('Delete users') || AuthService.can('Delete area managers'))) &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className="btn btn--xsmall btn--red" onClick={this.handleInputs.bind(this, user.id, "delete")} >Remove</a>
                                        </td>
                                    }
                                    {AuthService.can('delete store users') && AuthService.getAdminType() == 4 &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className="btn btn--xsmall btn--red" onClick={this.handleInputs.bind(this, user.id, "delete", AuthService.getUserId())} >Remove</a>
                                        </td>
                                    }
                                    {(AuthService.getAdminType() == 1 && (AuthService.can('Activate/Deactivate users') || AuthService.can('Activate/Deactivate area managers'))) &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a
                                                href="javascript:void(0)"
                                                className={user.isActive == 1 ? "btn btn--xsmall" : "btn btn--xsmall btn--blue"}
                                                style={{
                                                    paddingLeft: user.isActive == 1 ? "" : 28,
                                                    paddingRight: user.isActive == 1 ? "" : 28
                                                }}
                                                onClick={this.handleInputs.bind(
                                                    this,
                                                    user.id,
                                                    user.isActive == 1 ? "Deactivate" : "Activate"
                                                )}
                                            >
                                                {user.isActive == 1 ? "Deactivate" : "Activate"}
                                            </a>
                                        </td>
                                    }
                                    {AuthService.getAdminType() == 4 && AuthService.can('Activate/Deactivate store users') &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a
                                                href="javascript:void(0)"
                                                className={user.isActive == 1 ? "btn btn--xsmall" : "btn btn--xsmall btn--blue"}
                                                style={{
                                                    paddingLeft: user.isActive == 1 ? "" : 28,
                                                    paddingRight: user.isActive == 1 ? "" : 28
                                                }}
                                                onClick={this.handleInputs.bind(
                                                    this,
                                                    user.id,
                                                    user.isActive == 1 ? "Deactivate" : "Activate",
                                                    AuthService.getUserId()
                                                )}
                                            >
                                                {user.isActive == 1 ? "Deactivate" : "Activate"}
                                            </a>
                                        </td>
                                    }
                                    {AuthService.getAdminType() == 2 && AuthService.can('Activate/Deactivate store users') &&
                                        <td style={{ border: 0, background: "transparent" }}>
                                            <a href="javascript:void(0)" className={user.isActive == 1 ? "btn btn--xsmall" : "btn btn--xsmall btn--blue"} style={{ paddingLeft: user.isActive == 1 ? "" : 28, paddingRight: user.isActive == 1 ? "" : 28 }} onClick={this.handleInputs.bind(this, user.id, user.isActive == 1 ? "Deactivate" : "Activate")} >{user.isActive == 1 ? "Deactivate" : "Activate"}</a>
                                        </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        });
        function getIconForRole(role) {
            switch (role) {
                case 'Store User':
                    // return <FcManager />;
                    return <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon fill="#FF9800" points="24,37 19,31 19,25 29,25 29,31"></polygon><g fill="#FFA726"><circle cx="33" cy="19" r="2"></circle><circle cx="15" cy="19" r="2"></circle></g><path fill="#FFB74D" d="M33,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,18.9,33,14.1,33,13z"></path><path fill="#FF5722" d="M24,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H24z"></path><g fill="#784719"><circle cx="28" cy="19" r="1"></circle><circle cx="20" cy="19" r="1"></circle></g><path fill="#CFD8DC" d="M29,31L29,31l-5,1l-5-1c0,0-11,2-11,13h32C40,33,29,31,29,31z"></path><polygon fill="#3F51B5" points="23,35 22,44 26,44 25,35 26,34 24,32 22,34"></polygon></svg>;
                case 'Store Admin':
                    // return <FcServices />;
                    return <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="#E65100" d="M25.6,34.4c0.1-0.4,0.1-0.9,0.1-1.4s0-0.9-0.1-1.4l2.8-2c0.3-0.2,0.4-0.6,0.2-0.9l-2.7-4.6 c-0.2-0.3-0.5-0.4-0.8-0.3L22,25.3c-0.7-0.6-1.5-1-2.4-1.4l-0.3-3.4c0-0.3-0.3-0.6-0.6-0.6h-5.3c-0.3,0-0.6,0.3-0.6,0.6L12.4,24 c-0.9,0.3-1.6,0.8-2.4,1.4l-3.1-1.4c-0.3-0.1-0.7,0-0.8,0.3l-2.7,4.6c-0.2,0.3-0.1,0.7,0.2,0.9l2.8,2c-0.1,0.4-0.1,0.9-0.1,1.4 s0,0.9,0.1,1.4l-2.8,2c-0.3,0.2-0.4,0.6-0.2,0.9l2.7,4.6c0.2,0.3,0.5,0.4,0.8,0.3l3.1-1.4c0.7,0.6,1.5,1,2.4,1.4l0.3,3.4 c0,0.3,0.3,0.6,0.6,0.6h5.3c0.3,0,0.6-0.3,0.6-0.6l0.3-3.4c0.9-0.3,1.6-0.8,2.4-1.4l3.1,1.4c0.3,0.1,0.7,0,0.8-0.3l2.7-4.6 c0.2-0.3,0.1-0.7-0.2-0.9L25.6,34.4z M16,38c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5C21,35.8,18.8,38,16,38z"></path><path fill="#FFA000" d="M41.9,15.3C42,14.8,42,14.4,42,14s0-0.8-0.1-1.3l2.5-1.8c0.3-0.2,0.3-0.5,0.2-0.8l-2.5-4.3 c-0.2-0.3-0.5-0.4-0.8-0.2l-2.9,1.3c-0.7-0.5-1.4-0.9-2.2-1.3l-0.3-3.1C36,2.2,35.8,2,35.5,2h-4.9c-0.3,0-0.6,0.2-0.6,0.5l-0.3,3.1 c-0.8,0.3-1.5,0.7-2.2,1.3l-2.9-1.3c-0.3-0.1-0.6,0-0.8,0.2l-2.5,4.3c-0.2,0.3-0.1,0.6,0.2,0.8l2.5,1.8C24,13.2,24,13.6,24,14 s0,0.8,0.1,1.3l-2.5,1.8c-0.3,0.2-0.3,0.5-0.2,0.8l2.5,4.3c0.2,0.3,0.5,0.4,0.8,0.2l2.9-1.3c0.7,0.5,1.4,0.9,2.2,1.3l0.3,3.1 c0,0.3,0.3,0.5,0.6,0.5h4.9c0.3,0,0.6-0.2,0.6-0.5l0.3-3.1c0.8-0.3,1.5-0.7,2.2-1.3l2.9,1.3c0.3,0.1,0.6,0,0.8-0.2l2.5-4.3 c0.2-0.3,0.1-0.6-0.2-0.8L41.9,15.3z M33,19c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5C38,16.8,35.8,19,33,19z"></path></svg>;
                case 'CS Admin':
                    // return <FcDataConfiguration />;
                    return <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g fill="#D1C4E9"><path d="M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"></path><path d="M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"></path><path d="M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"></path></g><path fill="#607D8B" d="M45.2,38.1c0.1-0.4,0.1-0.8,0.1-1.1s0-0.8-0.1-1.1l2.3-1.7c0.2-0.2,0.3-0.5,0.2-0.7l-2.3-3.9 c-0.1-0.2-0.4-0.3-0.7-0.2l-2.6,1.2c-0.6-0.5-1.3-0.9-2-1.2l-0.3-2.9c0-0.3-0.3-0.5-0.5-0.5h-4.5c-0.3,0-0.5,0.2-0.5,0.5l-0.3,2.9 c-0.7,0.3-1.4,0.7-2,1.2l-2.6-1.2c-0.3-0.1-0.6,0-0.7,0.2l-2.3,3.9c-0.1,0.2-0.1,0.6,0.2,0.7l2.3,1.7c-0.1,0.4-0.1,0.8-0.1,1.1 s0,0.8,0.1,1.1l-2.3,1.7c-0.2,0.2-0.3,0.5-0.2,0.7l2.3,3.9c0.1,0.2,0.4,0.3,0.7,0.2l2.6-1.2c0.6,0.5,1.3,0.9,2,1.2l0.3,2.9 c0,0.3,0.3,0.5,0.5,0.5h4.5c0.3,0,0.5-0.2,0.5-0.5l0.3-2.9c0.7-0.3,1.4-0.7,2-1.2l2.6,1.2c0.3,0.1,0.6,0,0.7-0.2l2.3-3.9 c0.1-0.2,0.1-0.6-0.2-0.7L45.2,38.1z M37,42.2c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2 C42.2,39.9,39.9,42.2,37,42.2z"></path><path fill="#455A64" d="M37,31c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6s6-2.7,6-6C43,33.7,40.3,31,37,31z M37,40c-1.7,0-3-1.3-3-3 c0-1.7,1.3-3,3-3s3,1.3,3,3C40,38.7,38.7,40,37,40z"></path></svg>;
                default:
                    // return <FcGlobe />;
                    return <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="#7CB342" d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z"></path><path fill="#0277BD" d="M45,24c0,11.7-9.5,21-21,21S3,35.7,3,24S12.3,3,24,3S45,12.3,45,24z M23.8,33.7c0-0.4-0.2-0.6-0.6-0.8 c-1.3-0.4-2.5-0.4-3.6-1.5c-0.2-0.4-0.2-0.8-0.4-1.3c-0.4-0.4-1.5-0.6-2.1-0.8c-0.8,0-1.7,0-2.7,0c-0.4,0-1.1,0-1.5,0 c-0.6-0.2-1.1-1.1-1.5-1.7c0-0.2,0-0.6-0.4-0.6c-0.4-0.2-0.8,0.2-1.3,0c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.6,0.4-1.3,0.8-1.7 c0.6-0.4,1.3,0.2,1.9,0.2c0.2,0,0.2,0,0.4,0.2c0.6,0.2,0.8,1,0.8,1.7c0,0.2,0,0.4,0,0.4c0,0.2,0.2,0.2,0.4,0.2 c0.2-1.1,0.2-2.1,0.4-3.2c0-1.3,1.3-2.5,2.3-2.9c0.4-0.2,0.6,0.2,1.1,0c1.3-0.4,4.4-1.7,3.8-3.4c-0.4-1.5-1.7-2.9-3.4-2.7 c-0.4,0.2-0.6,0.4-1,0.6c-0.6,0.4-1.9,1.7-2.5,1.7c-1.1-0.2-1.1-1.7-0.8-2.3c0.2-0.8,2.1-3.6,3.4-3.1c0.2,0.2,0.6,0.6,0.8,0.8 c0.4,0.2,1.1,0.2,1.7,0.2c0.2,0,0.4,0,0.6-0.2c0.2-0.2,0.2-0.2,0.2-0.4c0-0.6-0.6-1.3-1-1.7c-0.4-0.4-1.1-0.8-1.7-1.1 c-2.1-0.6-5.5,0.2-7.1,1.7s-2.9,4-3.8,6.1c-0.4,1.3-0.8,2.9-1,4.4c-0.2,1-0.4,1.9,0.2,2.9c0.6,1.3,1.9,2.5,3.2,3.4 c0.8,0.6,2.5,0.6,3.4,1.7c0.6,0.8,0.4,1.9,0.4,2.9c0,1.3,0.8,2.3,1.3,3.4c0.2,0.6,0.4,1.5,0.6,2.1c0,0.2,0.2,1.5,0.2,1.7 c1.3,0.6,2.3,1.3,3.8,1.7c0.2,0,1-1.3,1-1.5c0.6-0.6,1.1-1.5,1.7-1.9c0.4-0.2,0.8-0.4,1.3-0.8c0.4-0.4,0.6-1.3,0.8-1.9 C23.8,35.1,24,34.3,23.8,33.7z M24.2,14.3c0.2,0,0.4-0.2,0.8-0.4c0.6-0.4,1.3-1.1,1.9-1.5c0.6-0.4,1.3-1.1,1.7-1.5 c0.6-0.4,1.1-1.3,1.3-1.9c0.2-0.4,0.8-1.3,0.6-1.9c-0.2-0.4-1.3-0.6-1.7-0.8c-1.7-0.4-3.1-0.6-4.8-0.6c-0.6,0-1.5,0.2-1.7,0.8 c-0.2,1.1,0.6,0.8,1.5,1.1c0,0,0.2,1.7,0.2,1.9c0.2,1-0.4,1.7-0.4,2.7c0,0.6,0,1.7,0.4,2.1L24.2,14.3z M41.8,29 c0.2-0.4,0.2-1.1,0.4-1.5c0.2-1,0.2-2.1,0.2-3.1c0-2.1-0.2-4.2-0.8-6.1c-0.4-0.6-0.6-1.3-0.8-1.9c-0.4-1.1-1-2.1-1.9-2.9 c-0.8-1.1-1.9-4-3.8-3.1c-0.6,0.2-1,1-1.5,1.5c-0.4,0.6-0.8,1.3-1.3,1.9c-0.2,0.2-0.4,0.6-0.2,0.8c0,0.2,0.2,0.2,0.4,0.2 c0.4,0.2,0.6,0.2,1,0.4c0.2,0,0.4,0.2,0.2,0.4c0,0,0,0.2-0.2,0.2c-1,1.1-2.1,1.9-3.1,2.9c-0.2,0.2-0.4,0.6-0.4,0.8 c0,0.2,0.2,0.2,0.2,0.4c0,0.2-0.2,0.2-0.4,0.4c-0.4,0.2-0.8,0.4-1.1,0.6c-0.2,0.4,0,1.1-0.2,1.5c-0.2,1.1-0.8,1.9-1.3,2.9 c-0.4,0.6-0.6,1.3-1,1.9c0,0.8-0.2,1.5,0.2,2.1c1,1.5,2.9,0.6,4.4,1.3c0.4,0.2,0.8,0.2,1.1,0.6c0.6,0.6,0.6,1.7,0.8,2.3 c0.2,0.8,0.4,1.7,0.8,2.5c0.2,1,0.6,2.1,0.8,2.9c1.9-1.5,3.6-3.1,4.8-5.2C40.6,32.4,41.2,30.7,41.8,29z"></path></svg>;
            }
        }

        return (
            (AuthService.can('view users') || (AuthService.can('view store users') && AuthService.getAdminType() == 4)) ?
                <div>
                    <div className="table--overflow clearfix margin--30--top" style={{ overflow: "auto" }}>
                        <div className="col">
                            <div className="col-2 gutter--40 ">
                                {window.location.pathname === '/new-users' ?
                                    <div className="col">
                                        <div className="col-2 gutter--40 ">
                                            <div className="col">
                                                <TextInput
                                                    name="uname"
                                                    label="Search by user"
                                                    placeholder="Search Users"
                                                    value={this.state.search}
                                                    onChange={this.handleSearch}
                                                />
                                            </div>
                                            <div className="col">
                                                <SelectInput
                                                    name="rle"
                                                    label="Search by role"
                                                    options={this.roles()}
                                                    value={this.state.selectedRole}
                                                    onChange={this.handleRoleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="col">
                                        <TextInput
                                            name="uname"
                                            label="Search by user"
                                            placeholder="Search Users"
                                            value={this.state.search}
                                            onChange={this.handleSearch}
                                        />
                                    </div>
                                }


                                <div className="col">
                                    <div className="col-2 gutter--40 ">
                                        <div className="col">
                                            <SelectInput
                                                name="store"
                                                label="Search by store"
                                                options={this.props.stores}
                                                value={this.state.selectedStore}
                                                onChange={this.handleStoreChange}
                                            />
                                        </div>
                                        <div className="col">
                                            <span className="sub-title text--grey" style={{ color: "white" }}>.</span><br />
                                                <button className="btn btn--small btn--color" onClick={this.handlePageRefresh}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    <br />
                        {window.location.pathname == '/new-users' &&
                            <div><FcManager /> Store User  &nbsp; &nbsp; <FcServices /> Store Admin &nbsp; &nbsp; <FcDataConfiguration /> CS Admin &nbsp; &nbsp; <FcGlobe /> Super Admin</div>
                        }
                        <table>
                            <thead>

                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
                                    Username &nbsp;
                                    {this.state.usernameSort === 'ASC' && <span onClick={() => this.handleUsernameSort('username')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&uarr;</b></span>}
                                    {this.state.usernameSort === 'DESC' && <span onClick={() => this.handleUsernameSort('username')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&darr;</b></span>}
                                </th>
                                {window.location.pathname == '/new-users' &&
                                    <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle' }}>Store/Role</th>
                                }
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle' }}>Timeout</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle' }}>Current Store</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
                                    Last Logged In &nbsp;
                                    {this.state.lastLoggedInSort === 'ASC' && <span onClick={() => this.handleUsernameSort('last_logged_in_time')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&uarr;</b></span>}
                                    {this.state.lastLoggedInSort === 'DESC' && <span onClick={() => this.handleUsernameSort('last_logged_in_time')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}><b>&darr;</b></span>}
                                </th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'middle', textAlign: 'center' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                            {rows.length === 0 &&
                                <tr>
                                    <td colSpan="7">No results founds.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    {this.props.totalUsers > 50 &&
                        <div style={paginationStyles}>
                            <nav>
                                <Pagination
                                    activePage={this.props.currentPage}
                                    itemsCountPerPage={50}
                                    totalItemsCount={this.props.isFiltering ? filteredLength : this.props.totalUsers}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    innerClass="pagination"
                                />
                            </nav>
                        </div>
                    }
                </div>
            </div>
            : <NotFound forbidden={true} />
        )
    }
}

export default UserTable;